import { message } from 'antd';
import { CompleteShift, IShift, IShiftCancel, ShiftAction, DeleteShiftType } from 'models';
import { Api } from './api';
import CrudService from './crud.service';
import { CreateFactory, GetAllInfiniteFactory, GetFactory, UpdateFactory } from './base.service';
import { BaseGetAllParams } from './defaults';

const BASE_URL = 'shifts';
const SERVICE_NAME = 'Shift';

class ShiftService<T> extends CrudService<T> {
  public async Complete(id: any, payload: any) {
    const result = await Api.put<Partial<T>, T>(`/shifts/${id}/complete`, payload);
    message.success(`${this.title} completed successfully`);
    return result;
  }
  public async Cancel(obj: IShiftCancel) {
    const result = await Api.put<IShiftCancel, T>(`/shifts/${obj.id}/cancel`, {
      ...{ cancellationAmountExclGst: 0 },
      ...obj,
    });
    message.success(`${this.title} cancelled successfully`);
    return result;
  }
  public async Ammend(obj: IShiftCancel) {
    const result = await Api.put<IShiftCancel, T>(`/shifts/${obj.id}/ammend`);
    message.success(`${this.title} ammended successfully`);
    return result;
  }
}

export interface GetAllParams extends BaseGetAllParams {
  contact?: string;
  assignee?: string;
  action?: ShiftAction;
  invoice?: string;
}

// Delete this soon
export default new ShiftService<IShift>(SERVICE_NAME, BASE_URL);

export const GetAll = GetAllInfiniteFactory<IShift, GetAllParams>(BASE_URL);
export const Get = GetFactory<IShift>(BASE_URL);
export const Create = CreateFactory<IShift>(BASE_URL, SERVICE_NAME);
export const Update = UpdateFactory<IShift>(BASE_URL, SERVICE_NAME);
export const Delete = async (id: string, type: DeleteShiftType) => {
  const result = await Api.delete(`/${BASE_URL}/${id}`, { type });
  message.success(`${SERVICE_NAME} deleted successfully`);
  return result;
};
export const Complete = async (payload: CompleteShift) => {
  const result = await Api.put<CompleteShift, IShift>(`/shifts/${payload.id}/complete`, payload);
  message.success(`${SERVICE_NAME} completed successfully`);
  return result;
};
export const Cancel = async (payload: IShiftCancel) => {
  const result = await Api.put<IShiftCancel, IShift>(`/${BASE_URL}/${payload.id}/cancel`, payload);
  message.success(`${SERVICE_NAME} cancelled successfully`);
  return result;
};
export const Ammend = async (id: string) => {
  const result = await Api.put<IShiftCancel, IShift>(`/${BASE_URL}/${id}/ammend`);
  message.success(`${SERVICE_NAME} ammended successfully`);
  return result;
};
